/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Courier,
  CourierResolver,
  CourierResolverAddRecordRequest,
  CourierSettings,
  MailOption,
  NewCourierResolver,
  NewRewardsAccount,
  RewardSettings,
  RewardsAccount,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
} from '../models/index';
import {
    CourierFromJSON,
    CourierToJSON,
    CourierResolverFromJSON,
    CourierResolverToJSON,
    CourierResolverAddRecordRequestFromJSON,
    CourierResolverAddRecordRequestToJSON,
    CourierSettingsFromJSON,
    CourierSettingsToJSON,
    MailOptionFromJSON,
    MailOptionToJSON,
    NewCourierResolverFromJSON,
    NewCourierResolverToJSON,
    NewRewardsAccountFromJSON,
    NewRewardsAccountToJSON,
    RewardSettingsFromJSON,
    RewardSettingsToJSON,
    RewardsAccountFromJSON,
    RewardsAccountToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
} from '../models/index';

export interface CourierResolverAddRecordOperationRequest {
    courierResolverAddRecordRequest?: CourierResolverAddRecordRequest;
}

export interface CourierResolverCountRequest {
    where?: string;
}

export interface CourierResolverCreateRequest {
    data?: NewCourierResolver;
}

export interface CourierResolverCreateChangeStreamGetCourierResolversChangeStreamRequest {
    options?: string;
}

export interface CourierResolverCreateChangeStreamPostCourierResolversChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface CourierResolverDeleteByIdRequest {
    id: string;
}

export interface CourierResolverExistsGetCourierResolversidExistsRequest {
    id: string;
}

export interface CourierResolverExistsHeadCourierResolversidRequest {
    id: string;
}

export interface CourierResolverFindRequest {
    filter?: string;
}

export interface CourierResolverFindByIdRequest {
    id: string;
    filter?: string;
}

export interface CourierResolverFindOneRequest {
    filter?: string;
}

export interface CourierResolverPatchOrCreateRequest {
    data?: CourierResolver;
}

export interface CourierResolverPrototypeCountCourierRewardsAccountsRequest {
    id: string;
    where?: string;
}

export interface CourierResolverPrototypeCreateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface CourierResolverPrototypeCreateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface CourierResolverPrototypeCreateCourierRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface CourierResolverPrototypeCreateCourierRewardsAccountsRequest {
    id: string;
    data?: NewRewardsAccount;
}

export interface CourierResolverPrototypeDeleteCourierRewardsAccountsRequest {
    id: string;
}

export interface CourierResolverPrototypeDestroyByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface CourierResolverPrototypeDestroyCourierCourierSettingRequest {
    id: string;
}

export interface CourierResolverPrototypeDestroyCourierMailOptionRequest {
    id: string;
}

export interface CourierResolverPrototypeDestroyCourierRewardSettingRequest {
    id: string;
}

export interface CourierResolverPrototypeFindByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface CourierResolverPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierResolverPrototypeGetCourierCourierSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierResolverPrototypeGetCourierMailOptionRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierResolverPrototypeGetCourierRewardSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierResolverPrototypeGetCourierRewardsAccountsRequest {
    id: string;
    filter?: string;
}

export interface CourierResolverPrototypePatchAttributesRequest {
    id: string;
    data?: CourierResolver;
}

export interface CourierResolverPrototypeUpdateByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
    data?: RewardsAccount;
}

export interface CourierResolverPrototypeUpdateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface CourierResolverPrototypeUpdateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface CourierResolverPrototypeUpdateCourierRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface CourierResolverReplaceByIdPostCourierResolversidReplaceRequest {
    id: string;
    data?: CourierResolver;
}

export interface CourierResolverReplaceByIdPutCourierResolversidRequest {
    id: string;
    data?: CourierResolver;
}

export interface CourierResolverReplaceOrCreatePostCourierResolversReplaceOrCreateRequest {
    data?: CourierResolver;
}

export interface CourierResolverReplaceOrCreatePutCourierResolversRequest {
    data?: CourierResolver;
}

export interface CourierResolverUpdateAllRequest {
    where?: string;
    data?: CourierResolver;
}

export interface CourierResolverUpsertWithWhereRequest {
    where?: string;
    data?: CourierResolver;
}

/**
 * 
 */
export class CourierResolverApi extends runtime.BaseAPI {

    /**
     */
    async courierResolverAddRecordRaw(requestParameters: CourierResolverAddRecordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/addRecord`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverAddRecordRequestToJSON(requestParameters['courierResolverAddRecordRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async courierResolverAddRecord(requestParameters: CourierResolverAddRecordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.courierResolverAddRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async courierResolverCountRaw(requestParameters: CourierResolverCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async courierResolverCount(requestParameters: CourierResolverCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierResolverCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async courierResolverCreateRaw(requestParameters: CourierResolverCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async courierResolverCreate(requestParameters: CourierResolverCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async courierResolverCreateChangeStreamGetCourierResolversChangeStreamRaw(requestParameters: CourierResolverCreateChangeStreamGetCourierResolversChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async courierResolverCreateChangeStreamGetCourierResolversChangeStream(requestParameters: CourierResolverCreateChangeStreamGetCourierResolversChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.courierResolverCreateChangeStreamGetCourierResolversChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async courierResolverCreateChangeStreamPostCourierResolversChangeStreamRaw(requestParameters: CourierResolverCreateChangeStreamPostCourierResolversChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async courierResolverCreateChangeStreamPostCourierResolversChangeStream(requestParameters: CourierResolverCreateChangeStreamPostCourierResolversChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.courierResolverCreateChangeStreamPostCourierResolversChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async courierResolverDeleteByIdRaw(requestParameters: CourierResolverDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async courierResolverDeleteById(requestParameters: CourierResolverDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.courierResolverDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async courierResolverExistsGetCourierResolversidExistsRaw(requestParameters: CourierResolverExistsGetCourierResolversidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverExistsGetCourierResolversidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async courierResolverExistsGetCourierResolversidExists(requestParameters: CourierResolverExistsGetCourierResolversidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.courierResolverExistsGetCourierResolversidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async courierResolverExistsHeadCourierResolversidRaw(requestParameters: CourierResolverExistsHeadCourierResolversidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverExistsHeadCourierResolversid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async courierResolverExistsHeadCourierResolversid(requestParameters: CourierResolverExistsHeadCourierResolversidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.courierResolverExistsHeadCourierResolversidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async courierResolverFindRaw(requestParameters: CourierResolverFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierResolver>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierResolverFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async courierResolverFind(requestParameters: CourierResolverFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierResolver>> {
        const response = await this.courierResolverFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async courierResolverFindByIdRaw(requestParameters: CourierResolverFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async courierResolverFindById(requestParameters: CourierResolverFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async courierResolverFindOneRaw(requestParameters: CourierResolverFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async courierResolverFindOne(requestParameters: CourierResolverFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierResolverGetRecordsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/getRecords`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async courierResolverGetRecords(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.courierResolverGetRecordsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async courierResolverPatchOrCreateRaw(requestParameters: CourierResolverPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async courierResolverPatchOrCreate(requestParameters: CourierResolverPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async courierResolverPrototypeCountCourierRewardsAccountsRaw(requestParameters: CourierResolverPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeCountCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardsAccounts/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async courierResolverPrototypeCountCourierRewardsAccounts(requestParameters: CourierResolverPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierResolverPrototypeCountCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async courierResolverPrototypeCreateCourierCourierSettingRaw(requestParameters: CourierResolverPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeCreateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async courierResolverPrototypeCreateCourierCourierSetting(requestParameters: CourierResolverPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.courierResolverPrototypeCreateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async courierResolverPrototypeCreateCourierMailOptionRaw(requestParameters: CourierResolverPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeCreateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async courierResolverPrototypeCreateCourierMailOption(requestParameters: CourierResolverPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.courierResolverPrototypeCreateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async courierResolverPrototypeCreateCourierRewardSettingRaw(requestParameters: CourierResolverPrototypeCreateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeCreateCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async courierResolverPrototypeCreateCourierRewardSetting(requestParameters: CourierResolverPrototypeCreateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.courierResolverPrototypeCreateCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async courierResolverPrototypeCreateCourierRewardsAccountsRaw(requestParameters: CourierResolverPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeCreateCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async courierResolverPrototypeCreateCourierRewardsAccounts(requestParameters: CourierResolverPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.courierResolverPrototypeCreateCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async courierResolverPrototypeDeleteCourierRewardsAccountsRaw(requestParameters: CourierResolverPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeDeleteCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async courierResolverPrototypeDeleteCourierRewardsAccounts(requestParameters: CourierResolverPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierResolverPrototypeDeleteCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async courierResolverPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters: CourierResolverPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierResolverPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async courierResolverPrototypeDestroyByIdCourierRewardsAccounts(requestParameters: CourierResolverPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierResolverPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async courierResolverPrototypeDestroyCourierCourierSettingRaw(requestParameters: CourierResolverPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeDestroyCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async courierResolverPrototypeDestroyCourierCourierSetting(requestParameters: CourierResolverPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierResolverPrototypeDestroyCourierCourierSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes mailOption of this model.
     */
    async courierResolverPrototypeDestroyCourierMailOptionRaw(requestParameters: CourierResolverPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeDestroyCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes mailOption of this model.
     */
    async courierResolverPrototypeDestroyCourierMailOption(requestParameters: CourierResolverPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierResolverPrototypeDestroyCourierMailOptionRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async courierResolverPrototypeDestroyCourierRewardSettingRaw(requestParameters: CourierResolverPrototypeDestroyCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeDestroyCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async courierResolverPrototypeDestroyCourierRewardSetting(requestParameters: CourierResolverPrototypeDestroyCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierResolverPrototypeDestroyCourierRewardSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async courierResolverPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters: CourierResolverPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierResolverPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async courierResolverPrototypeFindByIdCourierRewardsAccounts(requestParameters: CourierResolverPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.courierResolverPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async courierResolverPrototypeGetCourierRaw(requestParameters: CourierResolverPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async courierResolverPrototypeGetCourier(requestParameters: CourierResolverPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierResolverPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async courierResolverPrototypeGetCourierCourierSettingRaw(requestParameters: CourierResolverPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeGetCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async courierResolverPrototypeGetCourierCourierSetting(requestParameters: CourierResolverPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.courierResolverPrototypeGetCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async courierResolverPrototypeGetCourierMailOptionRaw(requestParameters: CourierResolverPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeGetCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async courierResolverPrototypeGetCourierMailOption(requestParameters: CourierResolverPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.courierResolverPrototypeGetCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async courierResolverPrototypeGetCourierRewardSettingRaw(requestParameters: CourierResolverPrototypeGetCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeGetCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async courierResolverPrototypeGetCourierRewardSetting(requestParameters: CourierResolverPrototypeGetCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.courierResolverPrototypeGetCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async courierResolverPrototypeGetCourierRewardsAccountsRaw(requestParameters: CourierResolverPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RewardsAccount>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeGetCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RewardsAccountFromJSON));
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async courierResolverPrototypeGetCourierRewardsAccounts(requestParameters: CourierResolverPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RewardsAccount>> {
        const response = await this.courierResolverPrototypeGetCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async courierResolverPrototypePatchAttributesRaw(requestParameters: CourierResolverPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async courierResolverPrototypePatchAttributes(requestParameters: CourierResolverPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async courierResolverPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters: CourierResolverPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierResolverPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async courierResolverPrototypeUpdateByIdCourierRewardsAccounts(requestParameters: CourierResolverPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.courierResolverPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update courierSetting of this model.
     */
    async courierResolverPrototypeUpdateCourierCourierSettingRaw(requestParameters: CourierResolverPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeUpdateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Update courierSetting of this model.
     */
    async courierResolverPrototypeUpdateCourierCourierSetting(requestParameters: CourierResolverPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.courierResolverPrototypeUpdateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update mailOption of this model.
     */
    async courierResolverPrototypeUpdateCourierMailOptionRaw(requestParameters: CourierResolverPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeUpdateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Update mailOption of this model.
     */
    async courierResolverPrototypeUpdateCourierMailOption(requestParameters: CourierResolverPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.courierResolverPrototypeUpdateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update rewardSetting of this model.
     */
    async courierResolverPrototypeUpdateCourierRewardSettingRaw(requestParameters: CourierResolverPrototypeUpdateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverPrototypeUpdateCourierRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/courier/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Update rewardSetting of this model.
     */
    async courierResolverPrototypeUpdateCourierRewardSetting(requestParameters: CourierResolverPrototypeUpdateCourierRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.courierResolverPrototypeUpdateCourierRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async courierResolverReplaceByIdPostCourierResolversidReplaceRaw(requestParameters: CourierResolverReplaceByIdPostCourierResolversidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverReplaceByIdPostCourierResolversidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async courierResolverReplaceByIdPostCourierResolversidReplace(requestParameters: CourierResolverReplaceByIdPostCourierResolversidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverReplaceByIdPostCourierResolversidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async courierResolverReplaceByIdPutCourierResolversidRaw(requestParameters: CourierResolverReplaceByIdPutCourierResolversidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierResolverReplaceByIdPutCourierResolversid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async courierResolverReplaceByIdPutCourierResolversid(requestParameters: CourierResolverReplaceByIdPutCourierResolversidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverReplaceByIdPutCourierResolversidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async courierResolverReplaceOrCreatePostCourierResolversReplaceOrCreateRaw(requestParameters: CourierResolverReplaceOrCreatePostCourierResolversReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async courierResolverReplaceOrCreatePostCourierResolversReplaceOrCreate(requestParameters: CourierResolverReplaceOrCreatePostCourierResolversReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverReplaceOrCreatePostCourierResolversReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async courierResolverReplaceOrCreatePutCourierResolversRaw(requestParameters: CourierResolverReplaceOrCreatePutCourierResolversRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async courierResolverReplaceOrCreatePutCourierResolvers(requestParameters: CourierResolverReplaceOrCreatePutCourierResolversRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverReplaceOrCreatePutCourierResolversRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async courierResolverUpdateAllRaw(requestParameters: CourierResolverUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async courierResolverUpdateAll(requestParameters: CourierResolverUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.courierResolverUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async courierResolverUpsertWithWhereRaw(requestParameters: CourierResolverUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierResolver>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/CourierResolvers/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierResolverToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierResolverFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async courierResolverUpsertWithWhere(requestParameters: CourierResolverUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierResolver> {
        const response = await this.courierResolverUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
